import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../redux/store'
import WrapperButton from '../../../components/WrapperButton'
import { GA, endPoints } from '../../../constants'
import {
	ButtonWrapper,
	LandingWrapper,
	ZeeLogoWrapper,
	MaxWidthWrapper,
	PlayWinText,
	StarGroup,
	PoweredByText,
	PoweredByLogo,
	PoweredByWrapper,
	ContentWrapper,
	ButtonSubWrapper,
} from './styles'
import kbcLogo from '../../../asset/kbc_logo.png'
import { useEffect, useState } from 'react'
// import { useTransition, animated } from 'react-spring'
import { validateSession } from '../../../redux/slices/user'
import { setWindowGA } from '../../../helpers/DTM'
import starsLogo from '../../../asset/stars.png'
import lenskartLogo from '../../../asset/LKLogoNewWhite.png'
import {
	setErrorStatus,
	updateNextRouteParams,
} from '../../../redux/slices/meta'
import { getOffersJSON } from '../../../redux/slices/offers'
import { APIMethods, ReqBodyWithoutHeaders } from '../../../types/state'
import { setErrorToast } from '../../../helpers/errorStyles'

const Landing = () => {
	const dispatch = useDispatch()
	const metaData = useSelector((state: RootState) => state.meta)
	const configData = useSelector((state: RootState) => state.offers)
	const translations = useSelector(
		(state: RootState) => state.translations.data
	)
	// 	const userData = useSelector((state: RootState) => state.user)

	// const [isLoaded, setIsLoaded] = useState(false)
	const [winnerLoading, setWinnerLoading] = useState(true)
	// const transition = useTransition(isLoaded, {
	// 	from: { x: 0, y: 950, opacity: 0, delay: 950 },
	// 	enter: { x: 0, y: 0, opacity: 1, delay: 950 },
	// 	leave: { x: 0, y: 950, opacity: 0, delay: 950 },
	// })

	// useEffect(() => {
	// 	setIsLoaded(true)
	// }, [])

	useEffect(() => {
		const data = {
			event: GA.eventName,
			pageName: GA.voteNowPage,
			pageURL: window.location.href,
			platform: metaData.platform,
		}
		setWindowGA(data)
		const reqObj: ReqBodyWithoutHeaders = {
			method: APIMethods.GET,
			url: endPoints.offersJSON,
			client: metaData.deviceType,
		}
		dispatch(getOffersJSON(reqObj))
	}, [dispatch, metaData.platform])

	useEffect(() => {
		if (metaData.isError) {
			setErrorToast(metaData.errorMessage)
			dispatch(setErrorStatus({ status: false, message: '' }))
		}
	}, [dispatch, metaData.isError, metaData.errorMessage])

	const onBtnClick = () => {
		dispatch(validateSession(metaData.deviceType))
	}

	const showScratchCard = () => {
		setWinnerLoading(false)
		dispatch(updateNextRouteParams('winners'))
		dispatch(validateSession(metaData.deviceType))
	}
	return (
		<>
			{/* {transition((style, item) =>
				item ? (
					<animated.div style={style}> */}
			<MaxWidthWrapper>
				<LandingWrapper>
					<ContentWrapper>
						<ZeeLogoWrapper
							src={kbcLogo}
							alt={translations.IIM_LOGO_ALT}
						/>
						<StarGroup src={starsLogo} alt="stars" />
						<PlayWinText>{translations.PLAY_WIN}</PlayWinText>
						<PoweredByWrapper>
							<PoweredByText>{translations.POWERED_BY}</PoweredByText>
							<PoweredByLogo src={lenskartLogo} alt="logo" />
						</PoweredByWrapper>
					</ContentWrapper>
					<ButtonSubWrapper>
						<ButtonWrapper>
							<WrapperButton
								isLoading={winnerLoading && metaData.isLoading}
								btnText={translations.START_VOTING}
								buttonClickHandler={onBtnClick}
								isEnabled={true}
							/>
						</ButtonWrapper>
						{configData.SHOW_WINNERS && (
							<ButtonWrapper>
								<WrapperButton
									isLoading={!winnerLoading}
									btnText={translations.SHOW_WINNERS}
									buttonClickHandler={showScratchCard}
									isEnabled={true}
								/>
							</ButtonWrapper>
						)}
					</ButtonSubWrapper>
				</LandingWrapper>
			</MaxWidthWrapper>
			{/* </animated.div>
				) : (
					''
				)
			)} */}
		</>
	)
}

export default Landing
